import { render, staticRenderFns } from "./MasterApprovalDetail.vue?vue&type=template&id=aded3e72&scoped=true&lang=pug&"
import script from "./scripts/MasterApprovalDetail.js?vue&type=script&lang=js&"
export * from "./scripts/MasterApprovalDetail.js?vue&type=script&lang=js&"
import style0 from "./MasterApprovalDetail.vue?vue&type=style&index=0&id=aded3e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aded3e72",
  null
  
)

export default component.exports